export default __webpack_public_path__ + "static/media/reverse.870bbf0d.svg";